import React from "react";
import { setCurrentView } from 'core/utils';
import { TaskPreviewEditTemplate } from 'themes/application/dashboard/pages';
import { TaskPreviewEditViewStore } from 'application/dashboard/stores';
import { observer } from 'mobx-react';

@setCurrentView((rootStore, componentProps) => new TaskPreviewEditViewStore(rootStore, componentProps), 'taskPreviewEditView')
@observer
class TaskPreviewEdit extends React.Component {
    render() {
        return <TaskPreviewEditTemplate {...this.props} />;
    }
}

export default TaskPreviewEdit;
